export const translations = {
  en: {
    // Nav
    nav: { home: 'Home', products: 'Products', contact: 'Contact', cart: 'Cart', login: 'Login', register: 'Sign Up', logout: 'Logout', profile: 'Profile', orders: 'My Orders', admin: 'Admin', search: 'Search products...', wishlist: 'Wishlist' },
    // Home
    home: {
      hero_badge: 'Premium Electronics Store',
      hero_title1: 'Pro-Grade',
      hero_title2: 'Electronics',
      hero_title3: 'For Professionals',
      hero_sub: 'Discover top-tier laptops, smartphones, audio gear, and more. Curated for professionals who demand excellence.',
      shop_now: 'Shop Now',
      view_featured: 'View Featured',
      free_shipping: 'Free Shipping',
      free_shipping_sub: 'On orders over $500',
      warranty: 'Warranty Included',
      warranty_sub: 'All products covered',
      support: '24/7 Support',
      support_sub: 'Expert tech support',
      fast_delivery: 'Fast Delivery',
      fast_delivery_sub: '2-3 business days',
      categories: 'Shop by Category',
      categories_sub: 'Find exactly what you need',
      featured: 'Featured Products',
      featured_sub: 'Handpicked for professionals',
      view_all: 'View All',
      newsletter_title: 'Stay in the Loop',
      newsletter_sub: 'Get exclusive deals, new arrivals and tech news.',
      newsletter_placeholder: 'Your email address',
      newsletter_btn: 'Subscribe',
      testimonials: 'What Our Customers Say',
    },
    // Products
    products: {
      title: 'Products',
      filters: 'Filters',
      category: 'Category',
      brand: 'Brand',
      price_range: 'Price Range',
      sort_by: 'Sort By',
      all_categories: 'All Categories',
      all_brands: 'All Brands',
      newest: 'Newest First',
      price_asc: 'Price: Low to High',
      price_desc: 'Price: High to Low',
      best_rated: 'Best Rated',
      popular: 'Most Popular',
      found: 'products found',
      no_results: 'No products found',
      clear_filters: 'Clear Filters',
      add_to_cart: 'Add to Cart',
      in_stock: 'In Stock',
      out_of_stock: 'Out of Stock',
      add: 'Add',
      reviews: 'reviews',
    },
    // Product Detail
    product: {
      specifications: 'Specifications',
      description: 'Description',
      reviews: 'Reviews',
      write_review: 'Write a Review',
      your_rating: 'Your Rating',
      comment: 'Comment',
      submit_review: 'Submit Review',
      add_to_cart: 'Add to Cart',
      buy_now: 'Buy Now',
      in_stock: 'In Stock',
      out_of_stock: 'Out of Stock',
      units_left: 'units left',
      sku: 'SKU',
      free_shipping: 'Free Shipping',
      orders_over: 'Orders $500+',
      easy_returns: 'Easy Returns',
      days: '30 days',
      based_on: 'Based on',
    },
    // Cart
    cart: {
      title: 'Shopping Cart',
      empty: 'Your cart is empty',
      empty_sub: 'Add some amazing products to get started',
      continue: 'Continue Shopping',
      clear: 'Clear Cart',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      tax: 'Tax (19%)',
      total: 'Total',
      free: 'FREE',
      checkout: 'Proceed to Checkout',
      add_more: 'Add ${{amount}} more for free shipping',
      summary: 'Order Summary',
    },
    // Checkout
    checkout: {
      title: 'Checkout',
      shipping_addr: 'Shipping Address',
      payment: 'Payment Method',
      review: 'Review',
      street: 'Street Address',
      city: 'City',
      state: 'State/Region',
      zip: 'Zip Code',
      country: 'Country',
      continue_payment: 'Continue to Payment',
      cash: 'Cash on Delivery',
      cash_sub: 'Pay when your order arrives',
      card: 'Credit/Debit Card',
      card_sub: 'Secure payment via Stripe',
      review_order: 'Review Your Order',
      place_order: 'Place Order',
      back: 'Back',
    },
    // Auth
    auth: {
      login_title: 'Welcome back',
      login_sub: 'Sign in to your account',
      register_title: 'Create account',
      register_sub: 'Join TechStore today',
      email: 'Email',
      password: 'Password',
      name: 'Full Name',
      confirm_pwd: 'Confirm Password',
      sign_in: 'Sign In',
      sign_up: 'Create Account',
      no_account: "Don't have an account?",
      have_account: 'Already have an account?',
      demo: 'Demo Credentials',
    },
    // Admin
    admin: {
      dashboard: 'Dashboard',
      products: 'Products',
      categories: 'Categories',
      orders: 'Orders',
      users: 'Users',
      discounts: 'Discounts',
      contact: 'Messages',
      settings: 'Settings',
      revenue: 'Total Revenue',
      total_orders: 'Total Orders',
      total_products: 'Products',
      total_users: 'Customers',
      recent_orders: 'Recent Orders',
      low_stock: 'Low Stock Alert',
      add_product: 'Add Product',
      edit_product: 'Edit Product',
      delete_product: 'Delete Product',
      add_category: 'Add Category',
      save: 'Save',
      cancel: 'Cancel',
      search: 'Search...',
      status: 'Status',
      actions: 'Actions',
      overview: 'Overview',
    },
    // Common
    common: {
      loading: 'Loading...',
      save: 'Save Changes',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      close: 'Close',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      search: 'Search',
      filter: 'Filter',
      view_all: 'View All',
      dark_mode: 'Dark Mode',
      light_mode: 'Light Mode',
      language: 'Language',
    },
    footer: {
      shop: 'Shop',
      account: 'Account',
      contact: 'Contact',
      rights: 'All rights reserved.',
      built: 'Built with Node.js & React',
    }
  },

  fr: {
    nav: { home: 'Accueil', products: 'Produits', contact: 'Contact', cart: 'Panier', login: 'Connexion', register: "S'inscrire", logout: 'Déconnexion', profile: 'Profil', orders: 'Mes Commandes', admin: 'Admin', search: 'Rechercher des produits...', wishlist: 'Favoris' },
    home: {
      hero_badge: 'Boutique Électronique Premium',
      hero_title1: 'Électronique',
      hero_title2: 'Professionnelle',
      hero_title3: 'Pour les Experts',
      hero_sub: 'Découvrez des ordinateurs portables, smartphones, équipements audio de premier ordre. Sélectionnés pour les professionnels.',
      shop_now: 'Acheter Maintenant',
      view_featured: 'Voir les Vedettes',
      free_shipping: 'Livraison Gratuite',
      free_shipping_sub: 'Pour les commandes +500$',
      warranty: 'Garantie Incluse',
      warranty_sub: 'Tous les produits couverts',
      support: 'Support 24/7',
      support_sub: 'Assistance technique experte',
      fast_delivery: 'Livraison Rapide',
      fast_delivery_sub: '2-3 jours ouvrables',
      categories: 'Acheter par Catégorie',
      categories_sub: 'Trouvez exactement ce dont vous avez besoin',
      featured: 'Produits Vedettes',
      featured_sub: 'Sélectionnés pour les professionnels',
      view_all: 'Voir Tout',
      newsletter_title: 'Restez Informé',
      newsletter_sub: 'Recevez des offres exclusives, nouveautés et actualités tech.',
      newsletter_placeholder: 'Votre adresse email',
      newsletter_btn: "S'abonner",
      testimonials: 'Ce que Disent Nos Clients',
    },
    products: {
      title: 'Produits',
      filters: 'Filtres',
      category: 'Catégorie',
      brand: 'Marque',
      price_range: 'Gamme de Prix',
      sort_by: 'Trier Par',
      all_categories: 'Toutes Catégories',
      all_brands: 'Toutes Marques',
      newest: 'Plus Récents',
      price_asc: 'Prix Croissant',
      price_desc: 'Prix Décroissant',
      best_rated: 'Mieux Notés',
      popular: 'Plus Populaires',
      found: 'produits trouvés',
      no_results: 'Aucun produit trouvé',
      clear_filters: 'Effacer Filtres',
      add_to_cart: 'Ajouter au Panier',
      in_stock: 'En Stock',
      out_of_stock: 'Rupture de Stock',
      add: 'Ajouter',
      reviews: 'avis',
    },
    product: {
      specifications: 'Spécifications',
      description: 'Description',
      reviews: 'Avis',
      write_review: 'Écrire un Avis',
      your_rating: 'Votre Note',
      comment: 'Commentaire',
      submit_review: 'Soumettre',
      add_to_cart: 'Ajouter au Panier',
      buy_now: 'Acheter Maintenant',
      in_stock: 'En Stock',
      out_of_stock: 'Rupture',
      units_left: 'unités restantes',
      sku: 'Référence',
      free_shipping: 'Livraison Gratuite',
      orders_over: 'Commandes +500$',
      easy_returns: 'Retours Faciles',
      days: '30 jours',
      based_on: 'Basé sur',
    },
    cart: {
      title: 'Mon Panier',
      empty: 'Votre panier est vide',
      empty_sub: 'Ajoutez des produits incroyables pour commencer',
      continue: 'Continuer les Achats',
      clear: 'Vider le Panier',
      subtotal: 'Sous-total',
      shipping: 'Livraison',
      tax: 'TVA (19%)',
      total: 'Total',
      free: 'GRATUIT',
      checkout: 'Passer la Commande',
      add_more: 'Ajoutez ${{amount}} pour la livraison gratuite',
      summary: 'Récapitulatif',
    },
    checkout: {
      title: 'Commande',
      shipping_addr: 'Adresse de Livraison',
      payment: 'Paiement',
      review: 'Révision',
      street: 'Rue',
      city: 'Ville',
      state: 'Région',
      zip: 'Code Postal',
      country: 'Pays',
      continue_payment: 'Continuer au Paiement',
      cash: 'Paiement à la Livraison',
      cash_sub: "Payez à la réception de votre commande",
      card: 'Carte Bancaire',
      card_sub: 'Paiement sécurisé via Stripe',
      review_order: 'Réviser la Commande',
      place_order: 'Confirmer la Commande',
      back: 'Retour',
    },
    auth: {
      login_title: 'Bon retour',
      login_sub: 'Connectez-vous à votre compte',
      register_title: 'Créer un compte',
      register_sub: 'Rejoignez TechStore',
      email: 'Email',
      password: 'Mot de passe',
      name: 'Nom Complet',
      confirm_pwd: 'Confirmer le Mot de passe',
      sign_in: 'Se Connecter',
      sign_up: 'Créer un Compte',
      no_account: "Pas de compte ?",
      have_account: 'Déjà un compte ?',
      demo: 'Identifiants Démo',
    },
    admin: {
      dashboard: 'Tableau de Bord',
      products: 'Produits',
      categories: 'Catégories',
      orders: 'Commandes',
      users: 'Utilisateurs',
      discounts: 'Remises',
      contact: 'Messages',
      settings: 'Paramètres',
      revenue: 'Revenus Totaux',
      total_orders: 'Total Commandes',
      total_products: 'Produits',
      total_users: 'Clients',
      recent_orders: 'Commandes Récentes',
      low_stock: 'Alerte Stock Faible',
      add_product: 'Ajouter Produit',
      edit_product: 'Modifier Produit',
      delete_product: 'Supprimer Produit',
      add_category: 'Ajouter Catégorie',
      save: 'Sauvegarder',
      cancel: 'Annuler',
      search: 'Rechercher...',
      status: 'Statut',
      actions: 'Actions',
      overview: 'Aperçu',
    },
    common: {
      loading: 'Chargement...',
      save: 'Sauvegarder',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      add: 'Ajouter',
      close: 'Fermer',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suivant',
      search: 'Rechercher',
      filter: 'Filtrer',
      view_all: 'Voir Tout',
      dark_mode: 'Mode Sombre',
      light_mode: 'Mode Clair',
      language: 'Langue',
    },
    footer: {
      shop: 'Boutique',
      account: 'Compte',
      contact: 'Contact',
      rights: 'Tous droits réservés.',
      built: 'Construit avec Node.js & React',
    }
  },

  ar: {
    nav: { home: 'الرئيسية', products: 'المنتجات', contact: 'اتصل بنا', cart: 'السلة', login: 'تسجيل الدخول', register: 'إنشاء حساب', logout: 'تسجيل الخروج', profile: 'الملف الشخصي', orders: 'طلباتي', admin: 'الإدارة', search: 'البحث عن منتجات...', wishlist: 'المفضلة' },
    home: {
      hero_badge: 'متجر الإلكترونيات المحترف',
      hero_title1: 'إلكترونيات',
      hero_title2: 'احترافية',
      hero_title3: 'للمحترفين',
      hero_sub: 'اكتشف أفضل أجهزة الكمبيوتر المحمول والهواتف الذكية ومعدات الصوت. مختارة للمحترفين الذين يطالبون بالتميز.',
      shop_now: 'تسوق الآن',
      view_featured: 'المنتجات المميزة',
      free_shipping: 'شحن مجاني',
      free_shipping_sub: 'للطلبات فوق 500$',
      warranty: 'ضمان شامل',
      warranty_sub: 'جميع المنتجات مشمولة',
      support: 'دعم 24/7',
      support_sub: 'دعم تقني متخصص',
      fast_delivery: 'توصيل سريع',
      fast_delivery_sub: '2-3 أيام عمل',
      categories: 'تسوق حسب الفئة',
      categories_sub: 'ابحث عن ما تحتاجه بالضبط',
      featured: 'المنتجات المميزة',
      featured_sub: 'مختارة للمحترفين',
      view_all: 'عرض الكل',
      newsletter_title: 'ابق على اطلاع',
      newsletter_sub: 'احصل على عروض حصرية وأحدث المنتجات وأخبار التكنولوجيا.',
      newsletter_placeholder: 'بريدك الإلكتروني',
      newsletter_btn: 'اشترك',
      testimonials: 'ماذا يقول عملاؤنا',
    },
    products: {
      title: 'المنتجات',
      filters: 'الفلاتر',
      category: 'الفئة',
      brand: 'العلامة التجارية',
      price_range: 'نطاق السعر',
      sort_by: 'ترتيب حسب',
      all_categories: 'كل الفئات',
      all_brands: 'كل العلامات',
      newest: 'الأحدث أولاً',
      price_asc: 'السعر: من الأقل',
      price_desc: 'السعر: من الأعلى',
      best_rated: 'الأعلى تقييماً',
      popular: 'الأكثر شعبية',
      found: 'منتج موجود',
      no_results: 'لا توجد منتجات',
      clear_filters: 'مسح الفلاتر',
      add_to_cart: 'أضف إلى السلة',
      in_stock: 'متوفر',
      out_of_stock: 'نفذ من المخزون',
      add: 'إضافة',
      reviews: 'تقييمات',
    },
    product: {
      specifications: 'المواصفات',
      description: 'الوصف',
      reviews: 'التقييمات',
      write_review: 'كتابة تقييم',
      your_rating: 'تقييمك',
      comment: 'التعليق',
      submit_review: 'إرسال التقييم',
      add_to_cart: 'أضف إلى السلة',
      buy_now: 'اشتر الآن',
      in_stock: 'متوفر',
      out_of_stock: 'نفذ',
      units_left: 'وحدة متبقية',
      sku: 'رمز المنتج',
      free_shipping: 'شحن مجاني',
      orders_over: 'للطلبات +500$',
      easy_returns: 'إرجاع سهل',
      days: '30 يوم',
      based_on: 'بناءً على',
    },
    cart: {
      title: 'سلة التسوق',
      empty: 'سلتك فارغة',
      empty_sub: 'أضف منتجات رائعة للبدء',
      continue: 'مواصلة التسوق',
      clear: 'إفراغ السلة',
      subtotal: 'المجموع الفرعي',
      shipping: 'الشحن',
      tax: 'الضريبة (19%)',
      total: 'الإجمالي',
      free: 'مجاني',
      checkout: 'إتمام الطلب',
      add_more: 'أضف ${{amount}} للشحن المجاني',
      summary: 'ملخص الطلب',
    },
    checkout: {
      title: 'إتمام الطلب',
      shipping_addr: 'عنوان التوصيل',
      payment: 'طريقة الدفع',
      review: 'مراجعة',
      street: 'الشارع',
      city: 'المدينة',
      state: 'الولاية/المنطقة',
      zip: 'الرمز البريدي',
      country: 'الدولة',
      continue_payment: 'متابعة للدفع',
      cash: 'الدفع عند الاستلام',
      cash_sub: 'ادفع عند استلام طلبك',
      card: 'بطاقة ائتمان',
      card_sub: 'دفع آمن عبر Stripe',
      review_order: 'مراجعة الطلب',
      place_order: 'تأكيد الطلب',
      back: 'رجوع',
    },
    auth: {
      login_title: 'مرحباً بعودتك',
      login_sub: 'سجل دخولك إلى حسابك',
      register_title: 'إنشاء حساب',
      register_sub: 'انضم إلى TechStore اليوم',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      name: 'الاسم الكامل',
      confirm_pwd: 'تأكيد كلمة المرور',
      sign_in: 'تسجيل الدخول',
      sign_up: 'إنشاء حساب',
      no_account: 'ليس لديك حساب؟',
      have_account: 'لديك حساب بالفعل؟',
      demo: 'بيانات تجريبية',
    },
    admin: {
      dashboard: 'لوحة التحكم',
      products: 'المنتجات',
      categories: 'الفئات',
      orders: 'الطلبات',
      users: 'المستخدمون',
      discounts: 'الخصومات',
      contact: 'الرسائل',
      settings: 'الإعدادات',
      revenue: 'إجمالي الإيرادات',
      total_orders: 'إجمالي الطلبات',
      total_products: 'المنتجات',
      total_users: 'العملاء',
      recent_orders: 'الطلبات الأخيرة',
      low_stock: 'تنبيه: مخزون منخفض',
      add_product: 'إضافة منتج',
      edit_product: 'تعديل المنتج',
      delete_product: 'حذف المنتج',
      add_category: 'إضافة فئة',
      save: 'حفظ',
      cancel: 'إلغاء',
      search: 'بحث...',
      status: 'الحالة',
      actions: 'الإجراءات',
      overview: 'نظرة عامة',
    },
    common: {
      loading: 'جاري التحميل...',
      save: 'حفظ التغييرات',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      add: 'إضافة',
      close: 'إغلاق',
      confirm: 'تأكيد',
      back: 'رجوع',
      next: 'التالي',
      search: 'بحث',
      filter: 'تصفية',
      view_all: 'عرض الكل',
      dark_mode: 'الوضع الداكن',
      light_mode: 'الوضع الفاتح',
      language: 'اللغة',
    },
    footer: {
      shop: 'التسوق',
      account: 'الحساب',
      contact: 'اتصل بنا',
      rights: 'جميع الحقوق محفوظة.',
      built: 'مبني بـ Node.js & React',
    }
  }
};

export const getT = (lang, section, key, vars = {}) => {
  let str = translations[lang]?.[section]?.[key] || translations['en']?.[section]?.[key] || key;
  Object.entries(vars).forEach(([k, v]) => { str = str.replace(`{{${k}}}`, v); });
  return str;
};
